import {
  ESCAPE_LOGIC_END_PLACEHOLDER,
  ESCAPE_LOGIC_END_RE,
  ESCAPE_LOGIC_END_REPLACE,
  ESCAPE_LOGIC_START_PLACEHOLDER,
  ESCAPE_LOGIC_START_RE,
  ESCAPE_LOGIC_START_REPLACE
} from './const'

export function escapeText(text: string) {
  return (text || '')
    .replace(new RegExp(ESCAPE_LOGIC_START_RE, 'g'), ESCAPE_LOGIC_START_PLACEHOLDER)
    .replace(new RegExp(ESCAPE_LOGIC_END_RE, 'g'), ESCAPE_LOGIC_END_PLACEHOLDER)
}

export function unescapeText(text: string) {
  return (text || '')
    .replace(new RegExp(ESCAPE_LOGIC_START_PLACEHOLDER, 'g'), ESCAPE_LOGIC_START_REPLACE)
    .replace(new RegExp(ESCAPE_LOGIC_END_PLACEHOLDER, 'g'), ESCAPE_LOGIC_END_REPLACE)
}

export function transformText(text: string) {
  return (text || '')
    .replace(new RegExp(ESCAPE_LOGIC_START_RE, 'g'), ESCAPE_LOGIC_START_REPLACE)
    .replace(new RegExp(ESCAPE_LOGIC_END_RE, 'g'), ESCAPE_LOGIC_END_REPLACE)
}
